/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {activityPageThreadedFeed} from '../api'

export const useMutationActivityPageThreadedFeed = createReactQueryMutationHook('activityPageThreadedFeed', activityPageThreadedFeed)
